module.exports = __webpack_public_path__ + "img/Vespaio Map icon.b5e0b629.png";